// hooks/useCotaUsuario.ts
import { useState, useEffect } from "react";
import { apartamentoService } from "../../../services/apartamentoService";
import { Apartamento } from "../../../interfaces/Apartamento";

export const useApartamento = (aptoId: number | undefined, fetch: boolean) => {
  const [isLoading, setIsLoading] = useState(true);
  const [apartamento, setApartamento] = useState<Apartamento | undefined>(
    undefined
  );

  useEffect(() => {
    const fetchApartamento = async () => {
      if (aptoId && fetch) {
        setIsLoading(true);
        setApartamento(undefined);
        try {
          const data = await apartamentoService(aptoId);
          if (data) {
            setApartamento(data);
          } else {
            setApartamento(undefined);
            console.error(
              "Dados não encontrados para o apartamento do usuário"
            );
          }
        } catch (error) {
          setApartamento(undefined);
          console.error("Erro ao buscar apartamento:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setApartamento(undefined);
        setIsLoading(false);
      }
    };

    fetchApartamento();
  }, [aptoId, fetch]); // Dependência de aptoId e fetch para garantir que a chamada seja feita quando necessário

  return { isLoading, apartamento };
};
